import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalState } from '@app/store/store';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { tap } from 'rxjs';

@UntilDestroy()
@Component({
    selector: 'app-renew-success',
    templateUrl: './renew-success.component.html',
    styleUrls: ['./renew-success.component.scss'],
    standalone: false
})
export class RenewSuccessComponent implements OnInit {
  constructor(private store: Store<GlobalState>, private router: Router) {}

  certType: string = '';
  automatic: boolean = false;
  showInfo: boolean = true;

  ngOnInit(): void {
    this.store
      .pipe(
        untilDestroyed(this),
        tap(store => {
          if (store.session) {
            if (store.session.automatic) {
              this.certType = 'RENEW_PAGE.SUCCESS_STEP.AUTOMATIC_SIGN';
              this.automatic = true;
            } else {
              this.certType = 'RENEW_PAGE.SUCCESS_STEP.REMOTE_SIGN';
            }
          }
          if (store.certificate) {
          }
        })
      )
      .subscribe();
  }

  goToHomepage() {
    this.router.navigate(['/homepage']);
  }

  goToActivatePage() {
    this.router.navigate(['/manageCert']);
  }
}
